import { createSlice } from '@reduxjs/toolkit';

import {
    INITIALIZE_VALUES,
    RESET,
    RESET_FORM,
    SAVE_PROPOSAL,
    SAVE_PROPOSAL_SUCCESS,
    SAVE_PROPOSAL_FAILURE,
    SET_IS_OPEN_MODAL,
    SET_MODE,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    initialValues: {
        id: null,
        name: '',
    },
    isOpenModal: false,
    saveProposal: {
        isSaving: false,
        errors: [],
    },
    mode: 'duplicate',
};

const duplicateProposalModalSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [INITIALIZE_VALUES]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
            state.mode = INITIAL_STATE.mode;
        },
        [SAVE_PROPOSAL]: (state) => {
            state.saveProposal = {
                ...state.saveProposal,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_PROPOSAL_FAILURE]: (state, action) => {
            state.saveProposal = {
                ...state.saveProposal,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_PROPOSAL_SUCCESS]: (state, action) => {
            state.saveProposal = {
                ...state.saveProposal,
                data: action.payload,
                isSaving: false,
            };
        },
        [SET_IS_OPEN_MODAL]: (state, action) => {
            state.isOpenModal = action.payload;
        },
        [SET_MODE]: (state, action) => {
            state.mode = action.payload;
        },
    },
});

export const createProposalModalActions = duplicateProposalModalSlice.actions;

export default duplicateProposalModalSlice.reducer;
